import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footerbar',
  templateUrl: './footerbar.component.html',
  styleUrls: ['./footerbar.component.scss']
  })
export class FooterbarComponent implements OnInit {

  public customerLogoVisible = true;

  constructor(public router: Router) { }

  ngOnInit() {
  }

  toggleCustomerLogo() {
    this.customerLogoVisible = !this.customerLogoVisible;
  }
}
